<template>
    <div>
        <!--ค่าขนส่ง-->
        <h4 class="text-center font-weight-bold">ค่าขนส่งลูกค้า</h4>
        <br>
        <div style="padding-left: 20px; font-weight: bold; font-size: 18px">
            {{form.customer_id}} {{form.store_name}}
        </div>
        <div class="row" style="margin: 15px;padding: 20px">
            <div class="row form-group">
                <div class="form-check" style="margin: 10px">
                    <input class="form-check-input" type="radio" value="1"
                           v-model="form.fixed_rate_status"
                           id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                        ค่าขนส่งต่อห่อ
                    </label>
                </div>
                <div class="form-check" style="margin: 10px">
                    <input class="form-check-input" type="radio" value="2"
                           v-model="form.fixed_rate_status"
                           id="defaultCheck2">
                    <label class="form-check-label" for="defaultCheck2">
                        ค่าขนส่งแบบเหมา
                    </label>
                </div>
            </div>
            <div class="row container-fluid">
                <table class="table table-borderless " style="text-align: center">
                    <thead>
                    <tr>
                        <th scope="col"></th>
                        <template v-for="transport in optionTransportType">
                            <th scope="col" v-if="transport.id != optionTransportType.length">{{transport.name}}</th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="transport in TransportForm">
                        <td style="text-align: right">{{transport[0].transport_wrap_name}}</td>
                        <td v-for="item in transport" v-if="item.transport_type_id != 4">
                            <input class="form-control"
                                   :disabled="(form.fixed_rate_status == 1 && item.transport_type_wrap_id == 1) || (form.fixed_rate_status == 2 && item.transport_type_wrap_id != 1)"
                                   v-model="item.price"
                                   type="number"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col text-center">
            <button type="button" @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>&nbsp;&nbsp;
        </div>
<!--        <pre>{{test_data}}</pre>-->
    </div>
</template>

<script>
    import {canViewSuperAdmin} from "../../../util/Permissions";
    import {mapState} from "vuex";

    export default {
        name: "EditTransportFoamModal",
        created() {
            this.$store.dispatch("Customer/getCustomerTransportPrice");
            this.$store.dispatch("Customer/getCustomerTransportForm");
        },
        computed: {
            canViewSuperAdmin,
            ...mapState({
                form: state => {
                    return state.Customer.CustomerForm;
                },
                OptionSeller: state => {
                    return state.Seller.data;
                },
                optionTransport: state => {
                    return state.TransportType.transportTypeList.filter(data => data.id != 4)
                },
                transport_form: state => {
                    return state.Customer.transport_form;
                },
                optionTransportType: state => {
                    return state.TransportType.transport_type_all;
                },
                user: state => {
                    return state.Auth.user;
                },
            }),
            TransportType() {
                if (this.form.transport_customer.length < 1) {
                    return this.optionTransport
                }
                return this.form.transport_customer
            },
            TransportForm() {
                if (this.form.transport_form.length < 1) {
                    return this.transport_form
                }
                return this.form.transport_form
            },
        },
        data(){
          return{
              test_data : null,
          }
        },
        methods:{
          submitData(){
              let data = {
                  customer_id : this.form.id,
                  fixed_rate_status : this.form.fixed_rate_status,
                  transport_form : this.TransportForm,
              }
              this.test_data = data;
              this.$emit("submit",data);
          },
          cancelData(){
              this.$emit("submit",false);
          }
        },
    }
</script>

<style scoped>
    a{
        cursor: pointer;
    }
    thead{
        background-color: white;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
